"use client";

import { FAQSection } from "@/components/sections/faq";
import { faq } from "@/lib/data/services-influencer-network-orchestration";

export function FAQ() {
  return (
    <FAQSection
      eyebrow={faq.eyebrow}
      title={faq.title}
      items={faq.items}
      accent={faq.accent}
    />
  );
}
